const data = {
  "comisions": [
    {
      "id": 1018,
      "name": "Comisión Conjunta para la Revisión Continua del Código Penal y para la Reforma de las Leyes Penales - Conjunta"
    },
    {
      "id": 1019,
      "name": "Comisión Conjunta para la Revisión e Implementación de Reglamentos Administrativos - Conjunta"
    },
    {
      "id": 1014,
      "name": "Comisión Conjunta para las Alianzas Público-Privadas de la Asamblea Legislativa - Conjunta"
    },
    {
      "id": 1017,
      "name": "Comisión Conjunta Permanente para la Revisión y Reforma del Código Civil de Puerto Rico - Conjunta"
    },
    {
      "id": 1015,
      "name": "Comisión Conjunta sobre Informes Especiales del Contralor - Conjunta"
    },
    {
      "id": 1020,
      "name": "Comisión Conjunta sobre Mitigación, Adaptación y Resiliencia al Cambio Climático - Conjunta"
    },
    {
      "id": 969,
      "name": "Comisión de Adultos Mayores y Bienestar Social - Cámara"
    },
    {
      "id": 965,
      "name": "Comisión de Agricultura - Cámara"
    },
    {
      "id": 994,
      "name": "Comisión de Agricultura - Senado"
    },
    {
      "id": 968,
      "name": "Comisión de Asuntos de la Juventud - Cámara"
    },
    {
      "id": 967,
      "name": "Comisión de Asuntos de la Mujer - Cámara"
    },
    {
      "id": 983,
      "name": "Comisión de Asuntos del Consumidor - Cámara"
    },
    {
      "id": 992,
      "name": "Comisión de Asuntos Federales y Veteranos - Cámara"
    },
    {
      "id": 966,
      "name": "Comisión de Asuntos Internos - Cámara"
    },
    {
      "id": 995,
      "name": "Comisión de Asuntos Internos - Senado"
    },
    {
      "id": 971,
      "name": "Comisión de Asuntos Municipales - Cámara"
    },
    {
      "id": 996,
      "name": "Comisión de Asuntos Municipales - Senado"
    },
    {
      "id": 979,
      "name": "Comisión de Banca, Seguros y Comercio - Cámara"
    },
    {
      "id": 997,
      "name": "Comisión de Ciencia, Tecnología e Inteligencia Artificial"
    },
    {
      "id": 981,
      "name": "Comisión de Cooperativismo - Cámara"
    },
    {
      "id": 972,
      "name": "Comisión de Desarrollo Económico - Cámara"
    },
    {
      "id": 998,
      "name": "Comisión de Desarrollo Económico, Pequeños Negocios, Banca, Comercio, Seguros y Cooperativismo - Senado"
    },
    {
      "id": 974,
      "name": "Comisión de Educación - Cámara"
    },
    {
      "id": 999,
      "name": "Comisión de Educación, Arte y Cultura - Senado"
    },
    {
      "id": 1021,
      "name": "Comisión de Ética - Senado"
    },
    {
      "id": 1000,
      "name": "Comisión de Familia, Asuntos de la Mujer, Personas de la Tercera Edad y Población con Diversidad Funcional - Senado"
    },
    {
      "id": 962,
      "name": "Comisión de Gobierno - Cámara"
    },
    {
      "id": 1001,
      "name": "Comisión de Gobierno - Senado"
    },
    {
      "id": 963,
      "name": "Comisión de Hacienda - Cámara"
    },
    {
      "id": 1002,
      "name": "Comisión de Hacienda, Presupuesto y PROMESA - Senado"
    },
    {
      "id": 1013,
      "name": "Comisión de Innovación, Reforma y Nombramientos - Senado"
    },
    {
      "id": 1004,
      "name": "Comisión de Juventud, Recreación y Deportes - Senado"
    },
    {
      "id": 989,
      "name": "Comisión de la Región Central - Cámara"
    },
    {
      "id": 988,
      "name": "Comisión de la Región Este - Cámara"
    },
    {
      "id": 986,
      "name": "Comisión de la Región Metro - Cámara"
    },
    {
      "id": 984,
      "name": "Comisión de la Región Norte - Cámara"
    },
    {
      "id": 987,
      "name": "Comisión de la Región Oeste - Cámara"
    },
    {
      "id": 985,
      "name": "Comisión de la Región Sur - Cámara"
    },
    {
      "id": 964,
      "name": "Comisión de Lo Jurídico - Cámara"
    },
    {
      "id": 1003,
      "name": "Comisión De Lo Jurídico - Senado"
    },
    {
      "id": 973,
      "name": "Comisión de Pequeños y Medianos Negocios - Cámara"
    },
    {
      "id": 1005,
      "name": "Comisión de Planificación, Permisos, Infraestructura y Urbanismo - Senado"
    },
    {
      "id": 975,
      "name": "Comisión de Recreación y Deportes - Cámara"
    },
    {
      "id": 976,
      "name": "Comisión de Recursos Naturales - Cámara"
    },
    {
      "id": 1006,
      "name": "Comisión de Relaciones Federales y Viabilización d…o del Pueblo para la Solución del Status - Senado"
    },
    {
      "id": 993,
      "name": "Comisión de Reorganización, Eficiencia y Diligencia - Cámara"
    },
    {
      "id": 977,
      "name": "Comisión de Salud - Cámara"
    },
    {
      "id": 1007,
      "name": "Comisión de Salud - Senado"
    },
    {
      "id": 990,
      "name": "Comisión de Seguridad Pública - Cámara"
    },
    {
      "id": 1008,
      "name": "Comisión de Seguridad Pública y Asuntos del Veterano - Senado"
    },
    {
      "id": 991,
      "name": "Comisión de Sistemas de Retiro - Cámara"
    },
    {
      "id": 1009,
      "name": "Comisión De Trabajo y Relaciones Laborales - Senado"
    },
    {
      "id": 978,
      "name": "Comisión de Transportación e Infraestructura - Cámara"
    },
    {
      "id": 1010,
      "name": "Comisión de Transportación, Telecomunicaciones, Servicios Públicos y Asuntos del Consumidor - Senado"
    },
    {
      "id": 980,
      "name": "Comisión de Turismo - Cámara"
    },
    {
      "id": 1011,
      "name": "Comisión de Turismo, Recursos Naturales y Ambientales - Senado"
    },
    {
      "id": 1012,
      "name": "Comisión de Vivienda y Bienestar Social - Senado"
    },
    {
      "id": 982,
      "name": "Comisión de Vivienda y Desarrollo Urbano - Cámara"
    },
    {
      "id": 970,
      "name": "Comisión del Trabajo y Asuntos Laborales - Cámara"
    },
    {
      "id": 1016,
      "name": "Comisión Especial Conjunta de Fondos Legislativos para Impacto Comunitario - Conjunta"
    }
  ]
}

export default data;